import React from "react";
import { Link } from "react-router-dom";

import { OpenCloseHoc } from "../hoc/index";
import { navigation } from "../dataObject/sidebar";
import { isEmpty, noop } from "lodash";

let selectedNav;
let isAdmin;
export const sidebarView = (props) => {
  selectedNav = props.location.pathname;
  isAdmin = props.isAdmin;
  return (
    <div className="page__sidebar sidebar">
      {printNav({ options: navigation })}
    </div>
  );
};

const renderOptions = (options) => {
  const isAdmin = localStorage.getItem("role") === "ADMIN";
  let pageSet;
  try {
    pageSet = JSON.parse(localStorage.getItem("pageSet"));
  } catch (e) {}

  return options.map((option, index) => {
    if (!isAdmin && option.id !== "heading") {
      const isExist =
        pageSet &&
        pageSet.length &&
        pageSet.find((pItem) => pItem.pageName === option.id);
      if (!isExist) {
        return null;
      }
    }
    return (
      <li
        key={`${index}${option.id}`}
        className={`accordionMenu__list${
          selectedNav === option.url ? "__active" : ""
        }`}
      >
        {printItem(option)}
      </li>
    );
  });
};
const printNav = ({ options, isChid = false }) => {
  return (
    <ul className={`accordionMenu ${isChid ? "accordionMenu__sub" : ""}`}>
      {renderOptions(options)}
    </ul>
  );
};

const printItem = (payload) => {
  const { displayLabel, iconName, options, url, isUnique } = payload;
  const _notHaveOptions = isEmpty(options);
  const IntelligenceCheck = localStorage.getItem("intelligence") === "false";
  let _label = (
    <span className="accordionMenu__list__item__label">{displayLabel}</span>
  );
  if (!isEmpty(url)) {
    _label = (
      <Link to={url}>
        <i className={`accordionMenu__list__item__icon fa ${iconName}`} />
        {_label}
      </Link>
    );
  } else {
    if (_notHaveOptions) {
      _label = (
        <div className="accordionMenu__subMenu">
          <i className={`accordionMenu__list__item__icon fa ${iconName}`} />
          {_label}
        </div>
      );
    } else {
      _label = (
        <React.Fragment>
          <i className={`accordionMenu__list__item__icon fa ${iconName} `} />
          {_label}
        </React.Fragment>
      );
    }
  }
  if (_notHaveOptions && isUnique) {
    _label = <React.Fragment>{_label}</React.Fragment>;
    return (
      <div className="accordionMenu__list__item accordionMenu__list__item__Unique">
        {_label}
      </div>
    );
  } else {
    return (
      <OpenCloseHoc
        isOpen={true}
        render={(props) => {
          const { isOpen, onHandleClick } = props;
          return (
            <React.Fragment>
              {IntelligenceCheck &&
              (displayLabel === "Intelligence" ||
                displayLabel === "Parse Requirements" ||
                displayLabel === "View Generated Test") ? (
                ""
              ) : (
                <div
                  className="accordionMenu__list__item"
                  onClick={_notHaveOptions ? noop : onHandleClick}
                >
                  {_label}
                  {_notHaveOptions ? null : (
                    <i
                      className={`accordionMenu__list__item__button fa fa-chevron-${
                        isOpen ? "down" : "right"
                      }`}
                    />
                  )}
                </div>
              )}
              {/* } */}
              {_notHaveOptions || !isOpen
                ? null
                : printNav({ options, isChid: true })}
            </React.Fragment>
          );
        }}
      />
    );
  }
};
